import ItemListView from "../../../components/ItemListView/ItemListView.vue";
import ItemView from "../../../components/ItemView/ItemView.vue";
import { revisions as _revisions } from "../../standardAttachables";
import partNumberAttachable from "../ApprovedPartNumbers/attachable.js";

const revisions = {
    ..._revisions
};

const datasheetsAttachable = {
    "label": "Datasheets",
    "key": "Datasheets",
    "local": true,
    "headers": [{
        "headerName": "File",
        "field": "File",
    }],
    "actions": [{
        "label": "Attach Datasheet",
        action({ form, pageItem }) {
            form.setConfig({
                "title": "Attach Datasheet",
                "type": "push",
                "location": `Database/Documents/${pageItem.ID}/Datasheets`,
                "fields": [{
                    "label": "Datasheet",
                    "name": "File",
                    "type": "file"
                }],
                preSubmitHook({ files }) {
                    return {
                        "File": files[0][0].name
                    };
                },
                async postSubmitHook({ files, db, typeRef }) {
                    if (files.length > 0 && files[0].length < 1) return;
                    for (const file of files) {
                        await db.upload(`Database/Documents/${pageItem.ID}/Datasheet`, file[0]);
                    }
                }
            });
            form.toggle();
        }
    }],
    "rowActions": [{
        "label": "Download",
        async action({ pageItem, rowItem, db }) {
            const url = await db.download(`Database/Documents/${pageItem.ID}/Datasheet/${rowItem.File}`);
            window.open(url, "_blank");
        }
    }]
};


export default [{
    "path": "/Database/EAFs",
    "component": { ...ItemListView },
    "name": "EAFs (Archived)",
    "meta": {
        "app": "Database",
        "name": "EAFs (Archived)",
        "sideNav": true,
        "sideNavSection": "Equipment Assessments",
        "appSwitcher": false,
        "icon": "database",
        "tableSettings": "EAFs",
        "dataPath": "Database/Refs/Documents",
        "selectionRoute": "Database/EAFs/{ID}",
        filter(item) {
            return item.Number.includes(".EAF-");
        }
    }
}, {
    "path": "/Database/EAFs/:id",
    "component": ItemView,
    "name": "EAF",
    "meta": {
        "app": "Database",
        "name": "EAF",
        "dataPathOverride": "Database/Documents/:id",
        title(item) {
            return item.Name;
        },
        "menuActions": [],
        "dataFields": [{
            "label": "Number",
            "key": "Number"
        }, {
            "label": "Parent",
            "key": "Parent",
            "link": "Database/:ParentType/:ParentID"
        }, {
            "label": "Is Completed",
            "key": "Completed",
            "type": "bool"
        },{
            "label": "Date Completed",
            "key": "Date.Completed",
            "type": "date"
        }, {
            "label": "Title",
            "key": "Title",
            "class": "md:col-span-3"
        }],
        "formMetadata": {
            "ParentType": "Documents"
        },
        "attachedItems": {
            "Revisions": {
                "attachables": [revisions]
            },
            "Equipment Assessments": {
                "attachables": [datasheetsAttachable, partNumberAttachable]
            }
        },

    }
}];
